import classNames from 'classnames';
import { FC } from 'react';
import Toggle from '../Toggle';
import { alignments } from './config';

interface iOverlayProps {
  dimensions: number[];
  isDay: boolean;
  isOn: boolean;
  setIsOn: (val: boolean) => void;
  setIsDay: (val: boolean) => void;
  setZoom: (change: number) => void;
  background?: { regio?: { x1: number; x2: number; y1: number; y2: number } } | null;

  alignment: string;
  support: string;

  width: number;
  height: number;

  widthError?: boolean;
  heightError?: boolean;
  scale: number;

  containerRef: any;
}

const Overlay: FC<iOverlayProps> = ({
  dimensions,
  children,
  isOn,
  isDay,
  setIsDay,
  setIsOn,
  background,
  alignment,
  support,
  width,
  height,

  widthError,
  heightError,
  scale,

  setZoom,
  containerRef,
}) => {
  const _handleDay = (val: any) => setIsDay(!!val);
  const _handleOn = (val: any) => setIsOn(!!val);
  const _handleZoom = (val: any) => {
    setZoom(val === '+' ? 1 : -1);
  };
  return (
    <>
      <div className='viewer-container' id='viewer' ref={containerRef}>
        <div
          className='overlay-wrapper'
          style={{
            width: `${(dimensions[0] ?? 0) * 100}%`,
            height: `${(dimensions[1] ?? 0) * 100}%`,
            transform: `scale(${scale})`,
          }}
        >
          <div
            style={{
              top: `${(background?.regio?.y1 ?? 0) * 100}%`,
              left: `${(background?.regio?.x1 ?? 0) * 100}%`,
              right: `${(1 - (background?.regio?.x2 ?? 1)) * 100}%`,
              bottom: `${(1 - (background?.regio?.y2 ?? 1)) * 100}%`,
              background: background?.regio ? 'rgba(0, 0, 0, 0.1)' : 'none',
            }}
            className='overlay'
          >
            <div className='container' style={{ alignItems: alignments[alignment] }}>
              {['FULL', 'STAND'].includes(support) && (
                <div className={classNames('board', support === 'STAND' && 'stand')} />
              )}
              {!!width && (
                <>
                  {/* <div className={classNames('height', heightError && 'error')}>
                    <label>~{height.toFixed(0)} cm</label>
                  </div> */}
                  <div className={classNames('width', widthError && 'error')}>
                    <label>{width.toFixed(0)} cm</label>
                  </div>
                </>
              )}
              {children}
            </div>
          </div>
        </div>
      </div>
      <div className='controllers'>
        <Toggle options={['ON', 'OFF']} label='Background' value={isDay} onChange={_handleDay} />
        <Toggle options={['ON', 'OFF']} label='Power' value={isOn} onChange={_handleOn} />
        {/* <Toggle options={['Room', 'Empty']} value={isWall} onChange={setIsWall} /> */}
      </div>
      <div className='controllers bottom'>
        <Toggle options={['-', '+']} label='Zoom' onChange={_handleZoom} />
      </div>
      <span className='warning'>Background not to scale</span>
    </>
  );
};

export default Overlay;
